import type { FC } from 'react';

import { tradeRoleOptions } from '@zen/Booking/helpers';
import type { FormFieldProps } from '@zen/Components/Form/FormField';

import FormSelect from '../FormSelect';

interface Props extends FormFieldProps {}

const FormTradeRoleSelect: FC<Props> = (props) => {
  return <FormSelect {...props} label="Trade role" options={tradeRoleOptions} placeholder="Select trade role" />;
};

export default FormTradeRoleSelect;
